<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
      <asideCom :activityIndex="8"></asideCom>
      <div class="my-content">
        <div class="top-choose">
          <div class="message" :class="{'choose':contentIndex===0}" @click="changeIndex(0)">{{$t('global.创作者')}}</div>
        </div>
        <AuthorList :itemList="list" :small="true" v-if="listLength > 0"></AuthorList>
        <content-empty v-else-if="listLength == 0" :content="$t('global.没有创作者记录')"></content-empty>
        <pages
          :page-size="pagerParam.pageSize"
          :page-count="pagerParam.pageCount"
          :current-page="pagerParam.currentPage"
          :total="pagerParam.total"
          @current-page-changed="OnCurrentPageChanged"
        ></pages>
      </div>
    </div>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import pages from "@/components/pages.vue";
import ContentEmpty from "@/components/ContentEmpty.vue";
import AuthorList from "@/components/author/AuthorList";

export default {
  name: "manageVideo",
  metaInfo() {
    return {
      title: this.$t("global.我的嘛酱") + " | MANA"
    };
  },
  data() {
    return {
      contentIndex: 0,
      list: [],
      listLength: -1,
      pagerParam: {
        pageSize: 20,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    ContentEmpty,
    AuthorList
  },
  created() {
    this.myMaJiang();
  },
  methods: {
    changeIndex(index) {
      this.contentIndex = index;
    },
    myMaJiang() {
      this.$http
        .get("/api/u/relation/fansList", {
          params: {
            pageIndex: this.pagerParam.currentPage
          }
        })
        .then(response => {
          let data = response.data;
          this.list = data.list;
          this.pagerParam.pageSize = data.pageSize;
          this.pagerParam.total = data.totalRecord;
          this.pagerParam.pageCount = data.totalPage;
          this.pagerParam.currentPage = data.pageIndex;
          this.listLength = this.list.length;
        });
    },
    gotoVideo(videoId) {
      this.$router.push("/Video/detail?id=" + videoId);
    },
    gotoHomePage(userId) {
      this.$router.push("/peopleCenter/" + userId);
    },
    focusFans(userId) {
      this.$http.post("/api/u/relation/follow/" + userId).then(response => {
        this.myMaJiang();
      });
    },
    cancleFocus(userId) {
      this.$http.post("/api/u/relation/unfollow/" + userId).then(response => {
        this.myMaJiang();
      });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.myMaJiang();
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.production-body {
  display: flex;
  flex-wrap: wrap;

  img {
    display: block;
    width: 2.06rem;
    height: 1.16rem;
    margin: 0.1rem 0 0 0.1rem;
    border-radius: 0.08rem;
  }
}

.my-content {
  width: 790px;
  background-color: #ffffff;
  padding: 40px;
  border-radius: 0.08rem;

  .top-choose {
    display: flex;
    justify-content: center;
    font-size: 0.26rem;
    color: #707070;

    span {
      display: block;
      margin: 0 0.65rem;
    }

    .choose {
      color: #333333;
      font-weight: bold;
    }
  }
}

.container {
  margin: 40px auto;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/MaJiang.vue